import {
  AUTHORIZATION_LOAD_ERROR,
  AUTHORIZATION_LOAD_SUCCESS,
  AUTHORIZATION_LOADING,
  AUTHORIZATION_COMMENT_LOADING,
  AUTHORIZATION_FORM_LOAD_SUCCESS,
  SET_CURRENT_FORM,
  SET_CURRENT_STEP,
  SET_ERROR,
  ADD_FILES,
  SET_STEP_ERROR,
  SET_BENEFICIARY,
  SET_BENEFICIARY_ERROR, 
  SET_INPUTS,
  RESET_AUTHORIZATION_STATE,
  SET_REIMBURSEMENT_STATUS,
  SET_CLAIM_TYPE,
  SET_LIST_AUTHORIZATION,
  SET_AUTHORIZATION,
  SET_AUTHORIZATION_ERROR,
  SET_SPONSOR_SLUG,
  SET_IS_REIMBURSEMENT,
  SET_AUTHORIZATION_CREATED
} from '../mutation-types';

export default {
  [AUTHORIZATION_LOAD_SUCCESS] (state, payload) {
    state.authorizations = payload.content
    state.links = payload.links
    state.page = payload.page
  },
  [AUTHORIZATION_LOAD_ERROR] (state) {
    state.errorAlert = true
  },
  [AUTHORIZATION_LOADING] (state, payload) {
    state.authorizationLoading = payload
  },
  [AUTHORIZATION_COMMENT_LOADING] (state, payload) {
    state.authorizationCommentLoading = payload
  },
  [AUTHORIZATION_FORM_LOAD_SUCCESS] (state, payload) {
    state.authorizationForms = payload.response
    state.authorizationFormsAndSteps = payload.formsByStep
  },
  [SET_CURRENT_FORM] (state, payload) {
    state.currentForm = payload
  },
  [SET_CURRENT_STEP] (state, payload) {
    state.currentStep = payload
  },
  [SET_ERROR] (state, payload) {
    state.error = payload
  },
  [ADD_FILES] (state, payload) {
    state.files = payload
  },
  [SET_STEP_ERROR] (state, payload) {
    state.stepError = payload
  },
  [SET_BENEFICIARY] (state, payload) {
    state.beneficiary = payload
  },
  [SET_BENEFICIARY_ERROR] (state, payload) {
    state.sponsorSlugError = payload
  },
  [SET_INPUTS](state, payload) {
    const { slug, value } = payload;
    const inputs = state.inputs;
    const index = inputs.findIndex(input => input.slug === slug);
    if (index >= 0) {
      inputs[index].value = value;
    } else {
      inputs.push({ slug, value });
    }
    state.inputs = inputs
  },
  [RESET_AUTHORIZATION_STATE] (state) {
    Object.assign(state, { files: [], inputs: [], sponsorSlugError: null, currentForm: null, claimType: null })
  },
  [SET_REIMBURSEMENT_STATUS] (state, payload) {
    state.reimbursementStatus = payload
  },
  [SET_CLAIM_TYPE] (state, payload) {
    state.claimType = payload
  },
  [SET_LIST_AUTHORIZATION] (state, payload) {
    state.listAuthorization = payload
  },
  [SET_AUTHORIZATION] (state, payload) {
    state.authorization = payload
  },
  [SET_AUTHORIZATION_ERROR] (state, payload) {
    state.authorizationError = payload
  },
  [SET_SPONSOR_SLUG] (state, payload) {
    state.sponsorSlug = payload
  },
  [SET_IS_REIMBURSEMENT] (state, payload) {
    state.isReimbursement = payload
  },
  [SET_AUTHORIZATION_CREATED](state, payload) {
    state.authorizationCreated = payload
  }
}